import React from "react";
import { FaStar } from "react-icons/fa";
import Footer from "../components/Footer";
import Header from "../components/Header";
import boy from "../img/girl.png";
import both from "../img/both.png";
import main from "../img/main.png";
import Children3Img from "../img/3_children.png";
import Review from "../components/Review";
import Package from "../components/Package";
import Protect from "../components/Protect";

const reviews = [
  {
    text: "Every educator should take this course. It gave me practical tools that I can use in my classroom immediately.",
    name: "Rachel Collins",
    work: "High School Teacher",
  },
  {
    text: "We switched to AngelWatch from another program, and the difference is night and day. This is the best emergency training available.",
    name: "Michael Trent",
    work: "Charter School Director",
  },
  {
    text: "This training was eye-opening. I learned more in a few hours than I did in years of traditional emergency training.",
    name: "Lisa Mendoza",
    work: "Daycare Owner, Director",
  },
];

export default function CareGiver() {
  return (
    <>
      <Header />
      <div className="font-sans  lg:p-0 pb-14">
        <div className="relative text-white">
          {/* Hero Image */}
          <div className="lg:h-[354px] h-[150px] w-full overflow-hidden">
            <img
              src={main}
              alt="How it works"
              className="w-full h-full object-cover"
            />
          </div>

          {/* Content Overlay */}
          <div className="absolute inset-0 flex items-center justify-start">
            <div className=" w-full max-w-7xl mx-auto px-4">
              <div className="flex flex-col">
                <h1
                  style={{ fontFamily: "Fredoka" }}
                  className="lg:text-[61px] text-[24px] font-bold mb-2 text-white"
                >
                  CareGiver
                </h1>
                <div
                  style={{ fontFamily: "Poppins" }}
                  className="text-white"
                >
                  Home &gt; <span className="text-white">CareGiver</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="">
          <div>
            {/* Top Section */}
            {/* Info Section */}
            <div className="text-gray-800  lg:py-10   space-y-5">
              {/* Header */}
              <div className="max-w-7xl mt-4 mx-auto flex flex-col md:flex-row items-center gap-6 md:gap-10 lg:mt-10 ">
                <div className="w-full md:w-6/12">
                  <h1
                    style={{
                      fontFamily: "Fredoka",

                      color: "black",
                      marginBottom: "5px",
                    }}
                    className=" text-[24px] p-2 lg:text-[34px] font-semibold mb-6 md:mb-10"
                  >
                    Emergency Training and Certification for Child Caregivers
                  </h1>
                  <p
                    className=" lg:text-[20px] text-[16px] lg:p-2 p-1 "
                    style={{
                      fontFamily: "poppins",
                     
                      color: "black",
                      marginBottom: "5px",
                    }}
                  >
                    Emergencies have a pattern of striking unexpectedly.
                    Caregivers are the first to respond and the most vital line
                    of protection. AngelWatch offers the only certification
                    program designed specifically for caregivers in child-based
                    environments.
                  </p>
                </div>

                <img
                  src={boy}
                  alt="Caregivers training"
                  className="w-full p-1 md:w-[460px] h-auto md:h-[374px] rounded "
                />
              </div>

              {/* Why Caregiver Training Matters */}
              <div className="max-w-7xl mx-auto ">
                <h2
                  style={{
                    fontFamily: "Fredoka",

                    color: "black",
                    marginBottom: "5px",
                  }}
                  className="lg:text-[34px] p-2 text-[20px] p-1 font-semibold text-black mb-4"
                >
                  WHY CAREGIVER TRAINING MATTERS
                </h2>
                <p
                  className="lg:text-[20px] p-3 text-[16px]  "
                  style={{
                    fontFamily: "poppins",
                    
                    color: "black",
                  }}
                >
                  Through both real-world scenarios and simulations, the
                  AngelWatch CareGiver program completes a vital role most don’t
                  talk about. We extend the emergency preparedness of daycares,
                  after-school programs, and early learning centers by creating
                  a consistent 24/7 plan in case of security breaches, natural
                  disasters, or medical emergencies.
                </p>
              </div>

              {/* What's Included */}
              <div className="max-w-7xl mx-auto ">
                <h2
                  className="font-semibold lg:text-[34px] text-[24px] p-3 pb-[15px]"
                  style={{
                    fontFamily: "Fredoka",

                    color: "black",
                  }}
                >
                  What’s Included In The AngelWatch Caregiver Certification
                </h2>
                <ul className="list-disc pl-6 mx-4 text-sm lg:space-y-3 space-y-1">
                  <li className="lg:text-[20px] text-[16px] lg:p-2 p-1 "
                    style={{
                      fontFamily: "poppins",
              
                      color: "black",
                    }}
                  >
                    Active Shooter Lockdown Procedures for family- or child-care settings
                  </li>
                  <li className="lg:text-[20px] text-[16px] lg:p-2 p-1 "
                    style={{
                      fontFamily: "poppins",
              
                      color: "black",
                    }}
                  >
                    Active Shooter and Lockdown Response Training for Child Care Settings
                  </li>
                  <li className="lg:text-[20px] text-[16px] lg:p-2 p-1 "
                    style={{
                      fontFamily: "poppins",
                  
                      color: "black",
                    }}
                  >
                    Immediate Downloadable Certification Upon Completion
                  </li>
                  <li className="lg:text-[20px] text-[16px] lg:p-2 p-1 "
                    style={{
                      fontFamily: "poppins",
                  
                      color: "black",
                    }}
                  >
                    24/7 Online Access to Complete Courses at Your Own Pace
                  </li>
                  <li className="lg:text-[20px] text-[16px] lg:p-2 p-1 "
                    style={{
                      fontFamily: "poppins",
                  
                      color: "black",
                    }}
                  >
                    {" "}
                    Annual Recertification Reminders to Stay Current
                  </li>
                </ul>
              </div>

              {/* Highlighted Section 1 */}
              <div className=" lg:p-[40px] p-4  mt-[30px] bg-[#FCF7EE]  rounded  text-sm lg:space-y-3 space-y-1">
                <div className="max-w-7xl mx-4 mx-auto ">
                  <h3
                    style={{
                      fontFamily: "Fredoka",
                      fontSize: "24px",
                      color: "black",
                    }}
                    className="font-semibold text-black pb-2 "
                  >
                    The Reality Most Educators Face
                  </h3>
                  <ul className="list-disc pl-5 lg:space-y-3 space-y-1">
                    <li className="lg:text-[20px] text-[16px] lg:p-2 p-1 "
                      style={{
                        fontFamily: "poppins",
                
                        color: "black",
                      }}
                    >
                      Most educators are unaware of the exact protocols during
                      active shooter, lockdown, or parent-related emergencies.
                    </li>
                    <li className="lg:text-[20px] text-[16px] lg:p-2 p-1 "
                      style={{
                        fontFamily: "poppins",
                 
                        color: "black",
                      }}
                    >
                      State-mandated emergency protocol training is rarely
                      delivered or often outdated.
                    </li>
                    <li className="lg:text-[20px] text-[16px] lg:p-2 p-1 "
                      style={{
                        fontFamily: "poppins",
               
                        color: "black",
                      }}
                    >
                      Many teachers don’t know what’s in their center’s
                      emergency plan—or whether it’s even compliant.
                    </li>
                    <li className="lg:text-[20px] text-[16px] lg:p-2 p-1 "
                      style={{
                        fontFamily: "poppins",
                      
                        color: "black",
                      }}
                    >
                      Most available trainings are passive video modules with no
                      testing, tracking, or certification.
                    </li>
                  </ul>
                </div>
              </div>

              {/* Highlighted Section 2 */}
              <div className=" max-w-7xl mx-4 mx-auto p-4 rounded  text-sm lg:space-y-3 space-y-1">
                <h3
                  style={{
                    fontFamily: "Fredoka",
                    fontSize: "24px",
                    color: "black",
                  }}
                  className="font-semibold text-black pb-2 "
                >
                  Why AngelWatch Is Different
                </h3>
                <ul className="list-disc pl-5 lg:space-y-3 space-y-1">
                  <li className="lg:text-[20px] text-[16px] lg:p-2 p-1 "
                    style={{
                      fontFamily: "poppins",
                    
                      color: "black",
                    }}
                  >
                    Designed exclusively for schools and daycares—not adapted
                    from corporate workplace safety.
                  </li>
                  <li className="lg:text-[20px] text-[16px] lg:p-2 p-1 "
                    style={{
                      fontFamily: "poppins",
                
                      color: "black",
                    }}
                  >
                    Built by an international defense contractor with experience
                    protecting U.S. government facilities worldwide.
                  </li>
                  <li className="lg:text-[20px] text-[16px] lg:p-2 p-1 "
                    style={{
                      fontFamily: "poppins",
                 
                      color: "black",
                    }}
                  >
                    Partnered with the American Red Cross, the American Heart
                    Association, and backed by the Department of Homeland
                    Security.
                  </li>
                  <li className="lg:text-[20px] text-[16px] lg:p-2 p-1 "
                    style={{
                      fontFamily: "poppins",
                  
                      color: "black",
                    }}
                  >
                    Patented, trademarked, and copyrighted to prevent dilution
                    or imitation.
                  </li>
                </ul>
              </div>
              {/* Highlighted Section 3 */}
              <div className="lg:p-[40px]  p-4 mt-[30px]  bg-[#FCF7EE] rounded  text-sm lg:space-y-3 space-y-1">
                <div className="max-w-7xl mx-4 mx-auto">
                  <h3
                    style={{
                      fontFamily: "Fredoka",
                      fontSize: "24px",
                      color: "black",
                    }}
                    className="font-semibold text-black pb-[15px] "
                  >
                    What You’ll Get
                  </h3>
                  <ul className="list-disc pl-5 lg:space-y-3 space-y-1">
                    <li className="lg:text-[20px] text-[16px] lg:p-2 p-1 "
                      style={{
                        fontFamily: "poppins",
                    
                        color: "black",
                      }}
                    >
                      12 months of unlimited access to the full AngelWatch
                      Emergency Management Certification System.
                    </li>
                    <li className="lg:text-[20px] text-[16px] lg:p-2 p-1 "
                      style={{
                        fontFamily: "poppins",
                     
                        color: "black",
                      }}
                    >
                      Interactive, scenario-based training that immerses you in
                      real-world crisis simulations.
                    </li>
                    <li className="lg:text-[20px] text-[16px] lg:p-2 p-1 "
                      style={{
                        fontFamily: "poppins",
                       
                        color: "black",
                      }}
                    >
                      Certification in active shooter response (internal &
                      external), combative parent scenarios, emergency
                      lockdowns, fire and weather protocols, and
                      shelter-in-place procedures.
                    </li>
                    <li className="lg:text-[20px] text-[16px] lg:p-2 p-1 "
                      style={{
                        fontFamily: "poppins",
                        
                        color: "black",
                      }}
                    >
                      Printable certificates for every module passed—ideal for
                      resumes and audit documentation.
                    </li>
                    <li className="lg:text-[20px] text-[16px] lg:p-2 p-1 "
                      style={{
                        fontFamily: "poppins",
                 
                        color: "black",
                      }}
                    >
                      Recognition through the AngelWatch National Safety &
                      Security Accreditation Program.
                    </li>
                  </ul>
                </div>
              </div>
              {/* Footer Notes */}
              <div className=" lg:p-[40px]  max-w-7xl mx-auto text-sm lg:space-y-3 space-y-1">
                <div className="mx-4">
                  <h3
                    style={{
                      fontFamily: "Fredoka",

                      color: "black",
                    }}
                    className="font-semibold lg:text-[24px] p-1 text-[20px] pb-[15px] text-black "
                  >
                    Perfect For:
                  </h3>
                  <ul className="list-disc p  lg:space-y-3 space-y-1 pl-5">
                    <li className="lg:text-[20px] text-[16px] lg:p-2 p-1 "
                      style={{
                        fontFamily: "poppins",
                      
                        color: "black",
                      }}
                    >
                      Public and private school teachers
                    </li>
                    <li className="lg:text-[20px] text-[16px] lg:p-2 p-1 "
                      style={{
                        fontFamily: "poppins",
                     
                        color: "black",
                      }}
                    >
                      Preschool and daycare workers
                    </li>
                    <li className="lg:text-[20px] text-[16px] lg:p-2 p-1 "
                      style={{
                        fontFamily: "poppins",
                    
                        color: "black",
                      }}
                    >
                      Anyone working in early childhood education
                    </li>
                    <li className="lg:text-[20px] text-[16px] lg:p-2 p-1 "
                      style={{
                        fontFamily: "poppins",
                    
                        color: "black",
                      }}
                    >
                      Substitute teachers, coaches, and support staff
                    </li>
                  </ul>
                </div>
              </div>
              <div className="lg:p-[40px] p-2 mt-[30px]  bg-[#FCF7EE] ">
                <div className="max-w-7xl mx-auto text-sm space-y-5">
                  <div className="mx-4">
                    <h3
                      style={{
                        fontFamily: "Fredoka",
                        fontSize: "24px",
                        color: "black",
                      }}
                      className="font-semibold pb-[15px] text-black "
                    >
                      Why You Need This Certification:
                    </h3>
                    <ul className="list-disc lg:space-y-3 space-y-1  pl-5">
                      <li className="lg:text-[20px] text-[16px] lg:p-2 p-1 "
                        style={{
                          fontFamily: "poppins",
                 
                          color: "black",
                        }}
                      >
                        Demonstrates that YOU are prepared, trained, and serious
                        about student safety.
                      </li>
                      <li className="lg:text-[20px] text-[16px] lg:p-2 p-1 "
                        style={{
                          fontFamily: "poppins",
                    
                          color: "black",
                        }}
                      >
                        Helps your center meet its state licensing requirements.
                      </li>
                      <li className="lg:text-[20px] text-[16px] lg:p-2 p-1 "
                        style={{
                          fontFamily: "poppins",
                        
                          color: "black",
                        }}
                      >
                        Gives parents confidence in you and your facility.
                      </li>
                      <li className="lg:text-[20px] text-[16px] lg:p-2 p-1 "
                        style={{
                          fontFamily: "poppins",
                        
                          color: "black",
                        }}
                      >
                        Anyone working in early childhood education
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            {/* Protect Your Children Section */}
            <div className="max-w-7xl mx-auto">
              <Protect img={Children3Img} />
            </div>

            {/* Pricing Section */}
            <div className="max-w-6xl mx-auto mt-10">
              <h2
                style={{
                  fontFamily: "Fredoka",

                  color: "black",
                  marginBottom: "5px",
                }}
                className="font-bold lg:text-[34px] text-[20px] text-center mb-12"
              >
                Ensures that if a crisis happens—you react with instinct, not
                panic.
              </h2>
            </div>

            {/* Testimonials & Email */}

            {/* Footer Bar */}
          </div>
        </div>
      </div>
      <div className="max-w-6xl mx-2 bg-[#F0AA00] mx-auto rounded-md p-4 lg:mt-10">
        <h2
          style={{ fontFamily: "Fredoka" }}
          className="lg:text-[30px] text-[20px] font-medium text-center text-white "
        >
          In a real crisis, hesitation costs lives. Many licensing agencies now
          require documented emergency preparedness training. AngelWatch
          Certification ensures you meet these standards and are fully ready to
          protect your children — and your career.
        </h2>
      </div>
      <h2
        style={{ fontFamily: "Fredoka" }}
        className="lg:text-[40px] text-[24px] mt-12  pb-14 font-bold text-center mb-12"
      >
        Prepare to Protect Lives — Get Certified Today
      </h2>
      <Package />

      <Review reviews={reviews} />
      <Footer />
    </>
  );
}
